import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Facebook, Instagram, Mail, Phone } from 'lucide-react';

// TikTok icon component
const TikTokIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

// Threads icon component
const ThreadsIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.057 7.164 1.43 1.781 3.631 2.695 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.964-.065-1.19.408-2.285 1.33-3.082.88-.76 2.119-1.207 3.583-1.291a13.853 13.853 0 0 1 3.02.142l-.126.742c-.76-.126-1.83-.178-2.893-.106-1.19.08-2.145.436-2.764 1.028-.6.572-.91 1.29-.872 2.022.035.89.507 1.59 1.33 1.977.635.298 1.401.434 2.215.386 1.19-.057 2.141-.522 2.831-1.382 1.046-1.302 1.113-3.243 1.1-4.324v-.07c-.013-.827-.098-1.613-.253-2.34-.272-1.277-.858-2.156-1.745-2.613-.768-.396-1.672-.583-2.687-.557h-.007c-1.086.006-2.067.216-2.915.639-.849.422-1.509 1.017-1.961 1.769-.453.751-.678 1.598-.67 2.518h-2.033c-.008-1.29.293-2.479.895-3.536.602-1.058 1.457-1.904 2.542-2.518 1.085-.615 2.337-.939 3.726-.968h.007c1.31-.03 2.483.223 3.487.757 1.004.533 1.78 1.316 2.308 2.328.33.632.576 1.335.732 2.096.156.761.235 1.561.235 2.38v.06c.013 1.414-.076 3.694-1.482 5.381-.874 1.05-2.117 1.655-3.706 1.8-1.202.088-2.361-.22-3.36-.92-1.098-.768-1.75-1.893-1.834-3.164-.083-1.27.408-2.432 1.382-3.268.928-.798 2.22-1.272 3.733-1.372 1.123-.08 2.261-.02 3.382.178l-.126.742c-.76-.126-1.83-.178-2.893-.106z"/>
  </svg>
);

// BlueSky icon component
const BlueSkyIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C2.566.944 1.561 1.266.902 1.565.139 1.908 0 3.08 0 3.768c0 .69.378 5.65.624 6.479.815 2.736 3.713 3.66 6.383 3.364.136-.02.275-.039.415-.056-.138.022-.276.04-.415.056-3.912.58-7.387 2.005-2.83 7.078 5.013 5.19 6.87-1.113 7.823-4.308.953 3.195 2.05 9.271 7.733 4.308 4.267-4.308 1.172-6.498-2.74-7.078a8.741 8.741 0 0 1-.415-.056c.14.017.279.036.415.056 2.67.297 5.568-.628 6.383-3.364.246-.828.624-5.79.624-6.478 0-.69-.139-1.861-.902-2.206-.659-.298-1.664-.62-4.3 1.24C16.046 4.748 13.087 8.687 12 10.8Z"/>
  </svg>
);

export const Header = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  const navItems = [
    { path: '/', label: 'Accueil' },
    { path: '/attelages', label: 'Attelages' },
    { path: '/securite', label: 'Sécurité' },
    { path: '/vision', label: 'Vision' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <header className="site-header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <div className="logo-container">
              <span className="logo-text">Pégase Liberté</span>
              <span className="logo-tagline">Les attelages qui vous donnent des ailes</span>
            </div>
          </Link>

          <nav className="desktop-nav">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <Link to="/contact" className="cta-button-header">
            Demande d'informations
          </Link>

          <button
            className="mobile-menu-button"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Menu"
          >
            {mobileMenuOpen ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
              </svg>
            )}
          </button>
        </div>

        {mobileMenuOpen && (
          <nav className="mobile-nav">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`mobile-nav-link ${location.pathname === item.path ? 'active' : ''}`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/contact"
              className="mobile-nav-link mobile-nav-cta"
              onClick={() => setMobileMenuOpen(false)}
            >
              Demande d'informations
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col">
            <h3 className="footer-title">Pégase Liberté</h3>
            <p className="footer-text">
              Les attelages qui vous donnent des ailes.
            </p>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Navigation</h4>
            <ul className="footer-links">
              <li><Link to="/">Accueil</Link></li>
              <li><Link to="/attelages">Attelages</Link></li>
              <li><Link to="/securite">Sécurité</Link></li>
              <li><Link to="/vision">Vision</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Contact</h4>
            <ul className="footer-contact">
              <li>
                <Phone size={16} />
                <span>06 70 79 93 09</span>
              </li>
              <li>
                <Mail size={16} />
                <span>Pegaseliberte@gmail.com</span>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Suivez-nous</h4>
            <div className="footer-social">
              <a href="https://facebook.com/pegaseliberte" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="https://tiktok.com/@pegase.liberte" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="TikTok">
                <TikTokIcon size={20} />
              </a>
              <a href="https://instagram.com/pegaseliberte" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="https://threads.net/@pegase_liberte" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Threads">
                <ThreadsIcon size={20} />
              </a>
              <a href="https://bsky.app/profile/pegaseliberte.bsky.social" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="BlueSky">
                <BlueSkyIcon size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Pégase Liberté. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};
